"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var RadioGroupContext = (0, react_1.createContext)({
    selectedId: undefined,
    setSelectedId: function () { },
});
exports.default = RadioGroupContext;
//# sourceMappingURL=RadioGroupContext.js.map